module.exports = __webpack_public_path__ + "media/kas1.10cffde5.mp4";